import 'owl.carousel';
import { create } from 'nouislider';

import { debounce } from '../../../node_modules/glo-shared-js/utils/helpers';
import { track } from '../../../node_modules/glo-shared-js/utils/analytics';
import { validatePromoCode } from '../../../node_modules/glo-shared-js/utils/validation';

import { addToSelections } from './utils/onboarding-selections';
import { getAdParams } from './utils/ad-params';

document.addEventListener('DOMContentLoaded', function() {
	const adParams = getAdParams();

	// Unfortunately, owlCarousel is dependent on jQuery being used -_-
	var onboardingCarousel = $('.onboarding-carousel');
	var isLoggedIn = !!document.getElementById('is-logged-in');

	if (isLoggedIn) {
		window.location.href = '/';
	}
	if (onboardingCarousel) {

		var focusMobileCentering = function() {
			if (window.innerWidth <= 768) {
				var outerContent = document.querySelector('.onboarding__focus-container');
				var innerContent = document.querySelector('.onboarding__focus-container > div');

				outerContent.scrollLeft = (innerContent.offsetWidth - outerContent.offsetWidth) / 2;
			}
		};

		var experienceSlider = function() {
			var sliders = document.querySelectorAll('.noUi-target');
			var sliderOptions = {
				start: 0,
				connect: [true, false],
				direction: 'rtl',
				step: 1,
				orientation: 'vertical',
				range: {
					'min': 0,
					'max': 4
				}
			};

			var getSliderColor = function(value) {
				switch (value) {
					case 1:
						return {
							border: '#FFE146',
							background: '#FFE146'
						};

					case 2:
						return {
							border: '#55C691',
							background: '#55C691'
						};

					case 3:
						return {
							border: '#00BAB6',
							background: '#00BAB6'
						};

					case 4:
						return {
							border: '#0055DC',
							background: '#0055DC'
						};

					default:
						return {
							border: '#82878f',
							background: '#82878f'
						};
				}
			};

			// Set up yoga and pilates slider
			for (var i = 0; i < sliders.length; i++) {
				create(sliders[i], sliderOptions);

				sliders[i].noUiSlider.on('update', function(values) {
					var value = parseInt(values[0], 10);
					var elementColors = getSliderColor(value);
					var modality = this.target.dataset.modality;

					this.target.querySelector('.noUi-handle').style.borderColor = elementColors.border;
					this.target.querySelector('.noUi-connect').style.background = elementColors.background;

					addToSelections('priorExperiences', value, modality);
				});
			}
		};

		onboardingCarousel.owlCarousel({
			loop: false,
			items: 1,
			nav: false,
			touchDrag: false,
			mouseDrag: false,
			URLhashListener: false,
			lazyLoad: true,
			smartSpeed: 500,
			nestedItemSelector: 'onboarding__card',
			dots: false,
			autoHeight: true,
			onInitialize: function() {
				var cancelLink = document.createElement('button');
				var cookieBanner = document.querySelector('.cookie-banner');
				var topNav = document.querySelector('.onboarding-carousel__top-nav').cloneNode(true);
				var dots = document.querySelector('.onboarding__dots').cloneNode(true);
				var cards = document.querySelectorAll('.onboarding__card');
				var gloLogo = document.querySelectorAll('.onboarding__logo');
				var valueProps = document.querySelector('.onboarding__value-props');
				var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit

				if (valueProps) {
					var valuePropsPrevBtn = document.querySelector('.onboarding__value-props-prev-btn');
					var valuePropsContainer = document.querySelector('.onboarding__value-props-container');

					cancelLink.classList = 'f-link f-link--no-underline f-link--btn f-medium onboarding-carousel__no-thanks-value-props';
					cancelLink.innerText = 'No thanks';

					// There is more logic in glo-shared-js default.js line 151
					if (cookieBanner) {
						valuePropsContainer.style.marginBottom = `${cookieBanner.clientHeight + 16}px`;

						window.addEventListener('resize', function() {
							valuePropsContainer.style.marginBottom = `${cookieBanner.clientHeight + 16}px`;
						});
					}
				}

				// Set the value in the --vh custom property to the root of the document
				document.documentElement.style.setProperty('--vh', `${vh}px`);

				// The onboarding "cards" are hidden by default.
				// Let's show them once the carousel is initialized
				document.querySelectorAll('.onboarding-carousel .onboarding__card').forEach(function(element) {
					element.classList.remove('hide');
				});

				document.querySelectorAll('.onboarding__header').forEach(function(element) {
					var clonedDots = dots.cloneNode(true);
					element.insertBefore(clonedDots, element.firstChild);
				});

				if (cards.length === 1) {
					cards.forEach(function(element) {
						var clonedTopNav = topNav.cloneNode(true);
						element.insertBefore(clonedTopNav, element.firstChild);
					});

					cards[0].querySelectorAll('.onboarding-carousel__skip').forEach(function(element) {
						element.remove();
					});

					cards[0].querySelectorAll('.owl-dots').forEach(function(element) {
						element.remove();
					});

					var btns = cards[0].querySelectorAll('.onboarding-carousel__next-btn');

					(btns || []).forEach(function(element) {
						element.innerText = element.getAttribute('data-first-value');
					});
				}

				if (isLoggedIn && cards.length === 1) {
					var lastCard = cards[cards.length - 1];
					var doneButton = document.createElement('button');
					doneButton.classList = 'btn btn--solid-dark onboarding-carousel__done-btn';
					doneButton.innerText = 'Done!';

					lastCard.querySelectorAll('.onboarding-carousel__next-btn').forEach(function(element) {
						element.remove();
					});

					lastCard.querySelectorAll('.onboarding-carousel__skip').forEach(function(element) {
						element.remove();
					});

					if (cards.length === 1 && document.getElementById('register-form__promo').value) {
						var attemptingApply = true;
						validatePromoCode(attemptingApply);
					}
				}

				if (valueProps) {
					valuePropsPrevBtn.addEventListener('click', function() {
						gloLogo.forEach(function(element) {
							element.classList.remove('hide');
						});

						valueProps.classList.add('hide');

						track('Page Viewed', {
							...adParams,
							page_name: 'Onboarding - Intro'
						});
					});
				}
			}
		});

		// Assign to the window so we have access in register.js
		window.onboardingCarousel = onboardingCarousel;

		window.addEventListener('resize', debounce(function() {
			var vh = window.innerHeight * 0.01;

			document.documentElement.style.setProperty('--vh', `${vh}px`);

			onboardingCarousel.trigger('refresh.owl.carousel');
		}, 250));

		// Remove the styles/teachers slide, and refresh to update state of nav dots
		var styleSelectionSlide = document.querySelector('.onboarding__card--styles');
		var teacherSelectionSlide = document.querySelector('.onboarding__card--teachers');

		if (styleSelectionSlide) {
			// Remove styles slide
			onboardingCarousel.trigger('remove.owl.carousel', 2).trigger('refresh.owl.carousel');
		}

		if (teacherSelectionSlide) {
			// Remove teachers slide
			onboardingCarousel.trigger('remove.owl.carousel', 3).trigger('refresh.owl.carousel');
		}

		onboardingCarousel.on('changed.owl.carousel', function(e) {
			// Scroll onboarding section to top of page
			window.scrollTo({
				top: document.querySelector('.onboarding__container').getBoundingClientRect().top + window.scrollY,
				behavior: 'smooth'
			});

			if (e.property.name === 'position') {
				var index = e.item.index;
				var nextItem = document.querySelectorAll('.onboarding__card')[index];
				var nextItemName = nextItem.getAttribute('data-slide');
				var topNav = nextItem.querySelector('.onboarding-carousel__top-nav');
				var skipMobile = nextItem.querySelector('.onboarding-carousel__skip--mobile');
				var prevButton = nextItem.querySelector('.onboarding-carousel__prev-btn');

				document.querySelectorAll('.owl-dot').forEach(function(element) {
					element.classList.remove('active');
				});

				topNav.classList.remove('onboarding-carousel__top-nav--gray', 'onboarding-carousel__top-nav--yellow', 'onboarding-carousel__top-nav--violet', 'onboarding-carousel__top-nav--blue', 'onboarding-carousel__top-nav--green');

				// To fix a bug in Safari 14 where the CC input field would appear empty
				if (document.getElementById('register-form')) {
					document.getElementById('register-form').style.display = 'none';
				}

				if (nextItemName === 'intro' || nextItemName === 'join') {
					prevButton.classList.add('hide');
					if (skipMobile) skipMobile.classList.add('hide');
				} else {
					prevButton.classList.remove('hide');
				}

				if (nextItemName === 'teachers') {
					document.querySelectorAll('.onboarding__avatar img').forEach(function(element) {
						element.setAttribute('src', element.getAttribute('data-src'));
					});
				}

				if (window.analytics && typeof window.analytics.page === 'function') {
					var hash = '#' + nextItemName;
					var valueProps = document.querySelector('.onboarding__value-props');
					var pageName;

					window.analytics.page({
						path: hash
					});

					switch (hash) {
						case '#save-preferences':
							pageName = 'Account Sign-up';
							break;

						case '#join':
							pageName = 'Payment Form';
							break;

						case '#intro':

							if (valueProps && !valueProps.classList.contains('hide')) {
								pageName = 'Value Propositions';
							} else {
								pageName = 'Intro';
							}
							break;

						default:
							pageName = nextItemName.charAt(0).toUpperCase() + nextItemName.substring(1);
					}

					track('Page Viewed', {
						...adParams,
						page_name: 'Onboarding - ' + pageName
					});
				}
			}
		});

		window.addEventListener('beforeunload', function(e) {
			var userMadeSelections = Object.keys(window.onboardingSelections).some(function(item) {
				var selection = window.onboardingSelections[item];

				if (Array.isArray(selection)) {
					return selection.length;
				} else {
					return Object.keys(selection).some(function(key) {
						return selection[key] !== null;
					});
				}
			});

			if (userMadeSelections) {
				// Cancel the event
				e.preventDefault();
				// Chrome requires returnValue to be set
				e.returnValue = '';
			}
		});

		experienceSlider();
		focusMobileCentering();
	}
});
